// @flow
import { ModuleInfotoolsActionTypes } from './constants';

type ModuleInfotoolsAction = { type: string, payload: {} | string };

// common success
export const moduleInfotoolsApiResponseSuccess = (actionType: string, data: any): ModuleInfotoolsAction => ({
    type: ModuleInfotoolsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const moduleInfotoolsApiResponseError = (actionType: string, error: string): ModuleInfotoolsAction => ({
    type: ModuleInfotoolsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getModuleInfotools = (key: string): ModuleInfotoolsAction => ({
    type: ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS,
    payload: { key },
});

// export const addModuleInfotools = (config:any):ModuleInfotoolsAction=>({
//     type:ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS,
//     payload:config
// })
// export const updateModuleInfotools = (config:any):ModuleInfotoolsAction=>({
//     type:ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS,
//     payload:config
// })
// export const deleteModuleInfotools = (id:string):ModuleInfotoolsAction=>({
//     type:ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS,
//     payload:{id}
// })

export const listModulesInfotools = (params:any): ModuleInfotoolsAction => ({
    type: ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS,
    payload: params,
});


export const resetModulesInfotools = (): ModuleInfotoolsAction => ({
    type: ModuleInfotoolsActionTypes.RESET,
    payload: {},
});

